<div class="modal-backdrop" (click)="onBackdropClick($event)"></div>

<div class="modal">
  <div class="modal-content">
    <div class="modal-header">
      <h2>Смена пароля</h2>
      <button class="close-button" (click)="onClose()" type="button">&times;</button>
    </div>

    <form #passwordForm="ngForm" (ngSubmit)="onSubmit()" class="change-password-form">
      @if (errorMessage()) {
        <div class="error-message">
          {{ errorMessage() }}
        </div>
      }

      @if (successMessage()) {
        <div class="success-message">
          {{ successMessage() }}
        </div>
      }

      <div class="field-wrapper">
        <mat-form-field appearance="outline" class="full-width" [class.field-error]="oldPasswordError()">
          <mat-label>Текущий пароль</mat-label>
          <input matInput
            #oldPasswordInput="ngModel"
            [type]="showOldPassword() ? 'text' : 'password'"
            id="oldPassword"
            [(ngModel)]="oldPasswordValue"
            name="oldPassword"
            (ngModelChange)="oldPassword.set($event); oldPasswordError.set(null)"
            [disabled]="isLoading()"
            required
            autocomplete="current-password"
          />
          <button mat-icon-button matSuffix type="button"
            (click)="toggleOldPasswordVisibility()"
            [disabled]="isLoading()">
            <mat-icon>{{ showOldPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          @if (oldPasswordInput.invalid && oldPasswordInput.touched) {
            <mat-error>Введите текущий пароль</mat-error>
          }
        </mat-form-field>
        @if (oldPasswordError()) {
          <div class="field-error-text">{{ oldPasswordError() }}</div>
        }
      </div>

      <div class="field-wrapper">
        <mat-form-field appearance="outline" class="full-width" [class.field-error]="newPasswordError()">
          <mat-label>Новый пароль</mat-label>
          <input matInput
            #newPasswordInput="ngModel"
            [type]="showNewPassword() ? 'text' : 'password'"
            id="newPassword"
            [(ngModel)]="newPasswordValue"
            name="newPassword"
            (ngModelChange)="newPassword.set($event); newPasswordError.set(null)"
            [disabled]="isLoading()"
            required
            minlength="6"
            autocomplete="new-password"
          />
          <button mat-icon-button matSuffix type="button"
            (click)="toggleNewPasswordVisibility()"
            [disabled]="isLoading()">
            <mat-icon>{{ showNewPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          @if (newPasswordInput.invalid && newPasswordInput.touched) {
            <mat-error>
              @if (newPasswordInput.errors?.['required']) {
                Введите новый пароль
              } @else if (newPasswordInput.errors?.['minlength']) {
                Минимум 6 символов
              }
            </mat-error>
          }
        </mat-form-field>
        @if (newPasswordError()) {
          <div class="field-error-text">{{ newPasswordError() }}</div>
        }
      </div>

      <div class="field-wrapper">
        <mat-form-field appearance="outline" class="full-width" [class.field-error]="confirmPasswordError()">
          <mat-label>Подтвердите новый пароль</mat-label>
          <input matInput
            #confirmPasswordInput="ngModel"
            [type]="showConfirmPassword() ? 'text' : 'password'"
            id="confirmPassword"
            [(ngModel)]="confirmPasswordValue"
            name="confirmPassword"
            (ngModelChange)="confirmPassword.set($event); confirmPasswordError.set(null)"
            [disabled]="isLoading()"
            required
            autocomplete="new-password"
          />
          <button mat-icon-button matSuffix type="button"
            (click)="toggleConfirmPasswordVisibility()"
            [disabled]="isLoading()">
            <mat-icon>{{ showConfirmPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
          @if (confirmPasswordInput.invalid && confirmPasswordInput.touched) {
            <mat-error>Подтвердите пароль</mat-error>
          }
          @if (confirmPasswordInput.valid && confirmPasswordValue && newPasswordValue !== confirmPasswordValue) {
            <mat-error>Пароли не совпадают</mat-error>
          }
        </mat-form-field>
        @if (confirmPasswordError()) {
          <div class="field-error-text">{{ confirmPasswordError() }}</div>
        }
      </div>

      <div class="button-group">
        <button
          type="button"
          class="btn-cancel"
          (click)="onClose()"
          [disabled]="isLoading()"
        >
          Отмена
        </button>
        <button
          type="submit"
          class="btn-submit"
          [disabled]="isLoading() || passwordForm.invalid || newPasswordValue !== confirmPasswordValue"
        >
          @if (isLoading()) {
            <mat-spinner diameter="20" color="accent"></mat-spinner>
            Сохранение...
          } @else {
            Изменить пароль
          }
        </button>
      </div>
    </form>
  </div>
</div>
